export default __webpack_public_path__ + "static/media/vector8.2942ee29.png";